import React from 'react'

import EstimationManagement from './abstract/EstimationManagement'
import Loading from '../../../common/component/Loading'
import PageHeader from '../../components/PageHeader'

class Dashboard extends EstimationManagement {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false
    }
  }
  componentWillMount () {
    this.loadRecentEstimationAndTemplateList()
  }
  loadRecentEstimationAndTemplateList () {
    // 一覧表示用の項目のみ・上位5件ずつをサーバ側で絞り込んで取得する
    const onSuccess = (res) => {
      const { real, template } = res.body.data
      this.setState({
        isRecentEstimationListLoaded: true,
        recentEstimationList: real.map(item => ({ id: item.estimationId, data: item })),
        isRecentTemplateListLoaded: true,
        recentTemplateList: template.map(item => ({ id: item.estimationId, data: item }))
      })
    }
    this.loadRecentEstimationList(onSuccess)
  }
  onDashButtonClicked (name) {
    switch (name) {
      case 'dashboard':
        this.props.history.push('/company_user')
        break
      case 'informationList':
        this.props.history.push('/company_user/information')
        break
      case 'sharedFileList':
        this.props.history.push('/company_user/shared_files')
        break
      case 'estimation':
        this.props.history.push('/company_user/estimation/real')
        break
      case 'estimationTemplate':
        this.props.history.push('/company_user/estimation/template')
        break
      case 'personalSettingHome':
        this.props.history.push('/company_user/personal_setting_home')
        break
      case 'surveyAnswer':
        this.props.history.push('/company_user/survey_answer')
        break
      default:
        break
    }
  }
  goEstimation (estimationType, estimationId, e) {
    this.props.history.push('/company_user/estimation/' + estimationType + '/detail/' + estimationId)
  }
  render () {
    if (!this.state.isRecentEstimationListLoaded || !this.state.isRecentTemplateListLoaded) {
      return <Loading />
    }
    const recentListStyle = {
      cursor: 'pointer',
      color: '#128dc2'
    }
    const recentEstimationList = this.state.recentEstimationList.map((estimation) => {
      return (
        <li key={estimation.data.estimationId} onClick={(e) => this.goEstimation('real', estimation.data.estimationId, e)} style={recentListStyle}>
          {estimation.data.estimationTitle}
        </li>
      )
    })
    const recentTemplateList = this.state.recentTemplateList.map((template) => {
      return (
        <li key={template.data.estimationId} onClick={(e) => this.goEstimation('template', template.data.estimationId, e)} style={recentListStyle}>
          {template.data.estiamtionprimeContractor}
        </li>
      )
    })
    return (
      <div>
        <PageHeader title='企業ユーザーマイページ' sub='こちらから全ての作業を開始できます。' history={this.props.history} />
        <section className='page container'>
          <div className='row'>
            <div className='span8'>
              <div className='box'>
                <div className='box-header'>
                  <i className='icon-bookmark' />
                  <h5>ショートカット</h5>
                </div>
                <div className='box-content'>
                  <h6>最近更新した見積書一覧</h6>
                  <ul>
                    {recentEstimationList}
                  </ul>
                  <h6>最近更新した見積書雛型一覧</h6>
                  <ul>
                    {recentTemplateList}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/Dashboard.js